import {IDispatcher, IListener, ISubscription} from '@src/@interfaces/services/Events';
import Dispatcher from '@src/services/Events/Dispatcher';
import {IEventEmitter} from '@src/@interfaces/services/Events/IEventEmitter';

export default class EventEmitter<TEvents extends string = string> implements IEventEmitter {
    constructor(
        protected dispatcher: IDispatcher = new Dispatcher()
    ) {
    }

    emit(eventName: TEvents, payload: any): void {
        this.dispatcher.dispatch(eventName, payload);
    }

    on<T>(eventName: TEvents, listener: IListener<T>): ISubscription {
        return this.dispatcher.listen<T>(eventName, listener);
    }

    once<T>(eventName: TEvents, listener: IListener<T>): ISubscription {
        return this.dispatcher.listenOnce<T>(eventName, listener);
    }

    flushListeners(): void {
        return this.dispatcher.flush();
    }
}
